import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * MAIA wizard — Step 3 of 4, final Enrich screen ("Portfolio ready").
 *
 * Shown once enrichment finishes. The enriched file can be downloaded; from here the user forks to
 * the Overview Report (Analyze & Report) or imports into Maptycs (prepare -> group) - both gated on
 * the user having clicked Download Enriched File first (hover tooltip explains why they're disabled).
 */
@Component({
    selector: "maia-ready-step",
    templateUrl: "./maia-ready-step.component.html",
    styleUrls: ["./maia-ready-step.component.scss"],
})
export class MaiaReadyStepComponent {
    @Input() datasetId: string | null = null;
    @Input() jobId: number | null = null;
    @Input() fileName = "";
    @Input() locationsDownloaded = false;

    @Output() readonly closeRequested = new EventEmitter<void>();
    @Output() readonly downloadRequested = new EventEmitter<void>();
    @Output() readonly overviewReportRequested = new EventEmitter<void>();
    @Output() readonly importRequested = new EventEmitter<void>();

    onOverviewReport(): void {
        if (this.locationsDownloaded) {
            this.overviewReportRequested.emit();
        }
    }

    onImport(): void {
        if (this.locationsDownloaded) {
            this.importRequested.emit();
        }
    }

    /** Hover tooltip on a gated button until Locations are downloaded; null (no tooltip) once they are. */
    gateHint(action: string): string | null {
        return this.locationsDownloaded ? null : "Download Enriched File to enable " + action;
    }
}
